import React, { Component, ReactNode } from 'react';
import './Login.scss';
import { AuthLayout } from '../layouts/auth-layout/AuthLayout';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { PasswordResetForm } from '../features/password-reset-form/PasswordResetForm';
import { AuthHelper } from '../helpers/AuthHelper';
import { ERouterPath } from '../features/router/ERouterPath';
import Button from 'react-bootstrap/Button';

interface PasswordResetParams {
  match: any;
}

class PasswordReset extends Component<RouteComponentProps<PasswordResetParams>> {
  private code: string;

  constructor(props: RouteComponentProps<any>) {
    super(props);

    const { code } = props.match.params as { code: string };

    this.code = code;

    AuthHelper.signOut();
  }

  handleReturn = (): void => {
    this.props.history.push(ERouterPath.login);
  };

  render(): ReactNode {
    return (
      <AuthLayout tip="Kies je nieuwe wachtwoord.">
        <PasswordResetForm code={this.code} />
        <Button className="form__link" variant="link" onClick={this.handleReturn}>
          Terug naar inloggen
        </Button>
      </AuthLayout>
    );
  }
}

export default withRouter(PasswordReset);
